var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRequested(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8105 4.8105L11.6895 2.6895C11.4083 2.40825 11.0265 2.25 10.629 2.25H5.25C4.42125 2.25 3.75 2.92125 3.75 3.75V14.25C3.75 15.0788 4.42125 15.75 5.25 15.75H12.75C13.5788 15.75 14.25 15.0788 14.25 14.25V5.871C14.25 5.4735 14.0918 5.09175 13.8105 4.8105V4.8105Z",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 6H11.25C10.836 6 10.5 5.664 10.5 5.25V2.25",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.5V8.25",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99925 12.5811C8.89575 12.5811 8.81175 12.6651 8.8125 12.7686C8.8125 12.8721 8.8965 12.9561 9 12.9561C9.1035 12.9561 9.1875 12.8721 9.1875 12.7686C9.1875 12.6651 9.1035 12.5811 8.99925 12.5811",
    stroke: "#E3A11F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequested);
export default __webpack_public_path__ + "static/media/Requested.ec25ed86774fa6536823f6eafb8a20ee.svg";
export { ForwardRef as ReactComponent };